export const socialLinks = {
  github: "https://github.com/Emilprivate",
  linkedin: "https://www.linkedin.com/in/emil-doganci",
  twitter: "https://x.com/EsdPriv",
  youtube: "https://www.youtube.com/@EmilPrivate/",
};
